import { useCallback } from 'react';
import JSB from '@bridge/sharee';
import { useFetch } from './use-fetch';
import logger from '../logger';
import { HttpMethod } from './fetch';

type FormSubmitProps = {
  formData: {
    [propName: string]: any;
  };
  isInApp: boolean;
  contentURL: string;
};

/**
 * 15s 中台如果还没有结果，不再等待请求结果，直接fail
 */
const timeoutFunc = () => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(false);
    }, 15000);
  });
};

export const useFormSubmit = () => {
  const fetch = useFetch();

  return useCallback(async (props: FormSubmitProps) => {
    const { formData, isInApp } = props;

    // 根据contentURL判断domain
    let res: any;
    // 约定全部走SG机房 - 绕过argus内测域名检测
    const domain = 'https://legal-1.byte'.concat('dance.net');
    // 由于Legal System接口是内网接口，都需要走node转发
    if (isInApp) {
      try {
        res = await Promise.race([
          JSB.app.fetch({
            url: 'https://www.lemon8-app.com/report/api/infringement/form',
            method: 'post',
            headers: JSON.stringify({ 'Content-Type': 'application/json' }),
            data: {
              formData,
              domain,
            },
            isInnerDomain: false,
          }),
          timeoutFunc(),
        ]);
      } catch (error) {
        logger.error(error, 'plugin report fetchformSubmit api /report/api/infringement/form error');
        // 如果请求发送失败，比如断网情况直接将res赋值为false
        res = false;
      }

      // JSB返回值会多包一层data
      if (res && res.msg === 'success' && res.code === 'A00000') {
        return true;
      } else {
        return false;
      }
    } else {
      try {
        res = await Promise.race([
          fetch('/report/api/infringement/form', {
            params: {
              formData,
              domain,
            },
            method: HttpMethod.post,
          }),
          timeoutFunc(),
        ]);
        // 如果请求发送失败，比如断网情况直接将res赋值为false
      } catch (error) {
        logger.error(error, 'plugin report fetchFormSubmit api  /report/api/infringement/form error');
        res = false;
      }

      if (res && res.msg === 'success' && res.code === 'A00000') {
        return true;
      } else {
        return false;
      }
    }
  }, []);
};
